



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ScoreBlockCard extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly diisiOleh!: string;
  @Prop({ type: String, default: "" }) readonly kategori!: string;
  @Prop({ type: String, default: "grey" }) readonly color!: string;
  @Prop({ type: Number, default: 0 }) readonly total!: number;
  @Prop({ type: Number, default: 0 }) readonly max!: number;

  get totalLabel(): string {
    return this.max ? `${this.total}/${this.max}` : String(this.total);
  }
}
